import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutCityLookup extends Layout {
    sourceCity: DataSource;
    tableCity: Table;
}
